import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
};

export const PhoneIcon = ({ width = 24, height = 24, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M7.24023 5.08252C7.90957 4.91519 8.61235 5.18625 8.99512 5.76025L9.91797 7.146C10.1378 7.47589 10.2235 7.87736 10.1562 8.26807C10.0654 8.79496 9.70892 9.23805 9.21387 9.43994L8.40137 9.771L7.76562 10.0298L8.01172 10.6704L8.16699 11.0747C9.06739 13.4157 10.9178 15.2661 13.2588 16.1665L13.6631 16.3218L14.3037 16.5679L14.5625 15.9321L14.8936 15.1196C15.0954 14.6246 15.5385 14.2681 16.0654 14.1772C16.4561 14.11 16.8576 14.1956 17.1875 14.4155L18.5732 15.3384C19.1472 15.7211 19.4183 16.4239 19.251 17.0933L18.9072 18.4702C18.7362 19.1538 18.1217 19.6331 17.417 19.6333C10.3938 19.6333 4.7002 13.9397 4.7002 6.9165C4.70035 6.21183 5.17966 5.59726 5.86328 5.42627L7.24023 5.08252Z"
                stroke={fill}
                strokeWidth="1.4"
            />
        </svg>
    );
};
